export const isValidEmail = (email) => {
  const emailFormat = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
  return (emailFormat).test(email);
};
